import styled from "styled-components";

export const Nav = styled.div`
  width: 100%;
  position: fixed;
  z-index: 20;
  height: 100px;
  transition: 0.5s;
  @media (max-width: 769px) {
    display: none;
  }
`;

export const NavContent = styled.div`
  display: flex;
  flex-direction: row;
  max-width: 1200px;
  height: 100px;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  padding-left: 20px;
  @media (max-width: 769px) {
    display: none;
  }
`;

export const NavLink = styled.a`
  color: #ffffff;
  text-decoration: none;
  font-weight: 500;
  cursor: pointer;
  padding: 30px;
  font-size: 1.25rem;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5);
`;

export const NavLogo = styled.img`
  width: 120px;
  height: 65px;
`;
